export default __webpack_public_path__ + "static/media/bannerSmall2.4ff14741.png";